import * as React from 'react'

import { Button } from '@thg-commerce/gravity-elements'

export interface BuyNowPayLaterTriggerProps {
  onClick: (e?: React.SyntheticEvent) => void
  i18nText: {
    triggerText: String
  }
}

export const BuyNowPayLaterTrigger = (props: BuyNowPayLaterTriggerProps) => {
  return (
    <Button
      sizing="regular"
      emphasis="low"
      onClick={(e) => {
        props.onClick(e)
      }}
      data-testid="buy-now-pay-later-trigger"
    >
      {props.i18nText.triggerText}
    </Button>
  )
}
